// OTP Method Selector Component
import React from 'react';
import { Phone, Mail, Check } from 'lucide-react';

const OTPMethodSelector = ({ availableMethods, preferredMethod, onSelect, loading, phoneNumber, email }) => {
  // Mask phone number for display
  const maskPhone = (phone) => {
    if (!phone) return '';
    if (phone.length <= 4) return phone;
    const last4 = phone.slice(-4);
    return `***${last4}`;
  };

  // Mask email for display
  const maskEmail = (email) => {
    if (!email) return '';
    const [local, domain] = email.split('@');
    if (local.length <= 2) return email;
    const masked = local[0] + '***' + local[local.length - 1];
    return `${masked}@${domain}`;
  };

  return (
    <div className="space-y-3">
      <p className="text-sm text-ink-soft mb-4">
        Choose how you'd like to receive your verification code:
      </p>

      {availableMethods.includes('SMS') && (
        <button
          type="button"
          onClick={() => onSelect('SMS')}
          disabled={loading}
          className={`w-full p-4 border-2 rounded-sm transition-colors duration-200 flex items-center justify-between ${
            preferredMethod === 'SMS'
              ? 'border-accent bg-accent-soft'
              : 'border-line hover:border-accent/50'
          } ${loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          <div className="flex items-center gap-3">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
              preferredMethod === 'SMS' ? 'bg-accent' : 'bg-paper'
            }`}>
              <Phone className={`w-5 h-5 ${
                preferredMethod === 'SMS' ? 'text-paper' : 'text-ink-soft'
              }`} />
            </div>
            <div className="text-left">
              <p className="font-semibold text-ink">SMS</p>
              <p className="text-sm text-ink-soft">
                {phoneNumber ? `Send code to ${maskPhone(phoneNumber)}` : 'Send code via text message'}
              </p>
            </div>
          </div>
          {preferredMethod === 'SMS' && (
            <Check className="w-5 h-5 text-accent" />
          )}
        </button>
      )}

      {availableMethods.includes('EMAIL') && (
        <button
          type="button"
          onClick={() => onSelect('EMAIL')}
          disabled={loading}
          className={`w-full p-4 border-2 rounded-sm transition-colors duration-200 flex items-center justify-between ${
            preferredMethod === 'EMAIL'
              ? 'border-accent bg-accent-soft'
              : 'border-line hover:border-accent/50'
          } ${loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          <div className="flex items-center gap-3">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
              preferredMethod === 'EMAIL' ? 'bg-accent' : 'bg-paper'
            }`}>
              <Mail className={`w-5 h-5 ${
                preferredMethod === 'EMAIL' ? 'text-paper' : 'text-ink-soft'
              }`} />
            </div>
            <div className="text-left">
              <p className="font-semibold text-ink">Email</p>
              <p className="text-sm text-ink-soft">
                {email ? `Send code to ${maskEmail(email)}` : 'Send code via email'}
              </p>
            </div>
          </div>
          {preferredMethod === 'EMAIL' && (
            <Check className="w-5 h-5 text-accent" />
          )}
        </button>
      )}

      {availableMethods.length === 0 && (
        <div className="p-4 bg-brass/10 border border-brass/30 rounded-sm">
          <p className="text-sm text-brass-deep">
            No OTP methods available. Please contact administrator to configure phone or email.
          </p>
        </div>
      )}
    </div>
  );
};

export default OTPMethodSelector;

